import { useRef } from 'react'

export const useCountdown = (): {
    cancel: () => void
    start: (timeMs: number, callback: () => void) => void
} => {
    const timeoutRef = useRef<null | NodeJS.Timeout>(null)

    return {
        cancel: () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
        },
        start: (timeMs, callback) => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            timeoutRef.current = setTimeout(callback, timeMs)
        },
    }
}
